import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FCFCFC\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#A2001D\" d=\"M4.957 11.129 3.652 8.763l1.305-2.33 1.304 2.33zM2.347 11.129 1.043 8.763l1.304-2.33 1.305 2.33zM4.957 17.565l-1.305-2.367 1.305-2.33 1.304 2.33zM2.347 17.565l-1.304-2.367 1.304-2.33 1.305 2.33zM6.26 2.329l-.369-.66q-.995.591-1.856 1.356l.921 1.67zM4.954 19.304l-.93 1.662c.571.51 1.192.964 1.854 1.357l.38-.69z\"></path><path fill=\"#6DA544\" d=\"M7.305 15.13v7.916A12 12 0 0 0 12 24c5.16 0 9.558-3.256 11.254-7.826z\"></path><path fill=\"#A2001D\" d=\"M23.254 16.174c.482-1.3.746-2.706.746-4.174 0-6.627-5.372-12-12-12-1.666 0-3.253.34-4.695.954v15.22z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }